import React from 'react';


export const VPC = props => {
    return (
        <img className={props.className} src={require('../../../../resources/images/aws_icons/vpc.png')} />
    )
};
